import { formatMoney } from "@/lib/currency";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const currency = (n) => formatMoney(n);

export const idr = (n) => {
  if (n >= 1e9) return `IDR ${(n / 1e9).toFixed(n % 1e9 === 0 ? 0 : 2)} bn`;
  if (n >= 1e6) return `IDR ${Math.round(n / 1e6)} M`;
  return `IDR ${Math.round(n).toLocaleString("en-US")}`;
};

export const plotPrice = (l, sqm, perAre = l.price_idr_per_are) => {
  const idrTotal = (sqm / 100) * perAre;
  return { idr: idrTotal, usd: Math.round(idrTotal / l.fx_idr_per_usd) };
};

export const plotPriceLabel = (l, sqm, perAre) => {
  const p = plotPrice(l, sqm, perAre);
  return `${idr(p.idr)} · ≈ ${currency(p.usd)}`;
};

export const compact = (n) => formatMoney(n, { notation: "compact" });
